var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "app-header no-print",
      class: { "transparent-nav": _vm.isTransparentNav },
      on: { mouseleave: _vm.hideExtendedMenu },
    },
    [
      _c("modal-login", {
        attrs: { shown: _vm.modal === "login", recovery: _vm.isRecoveryMode },
        on: { close: _vm.hideModal },
      }),
      _vm._v(" "),
      _c("modal-register", {
        attrs: { shown: _vm.modal === "register" },
        on: { close: _vm.hideModal },
      }),
      _vm._v(" "),
      _c("modal-details", {
        attrs: { shown: _vm.modal === "details" },
        on: { close: _vm.hideModal },
      }),
      _vm._v(" "),
      _c("modal-subscriber-details", {
        attrs: { shown: _vm.modal === "subscriber-details" },
        on: { close: _vm.hideModal },
      }),
      _vm._v(" "),
      _vm.settingsModal === "notifications"
        ? _c("notifications-dashboard")
        : _vm._e(),
      _vm._v(" "),
      _c("cookie-law"),
      _vm._v(" "),
      _vm.isMobileMenuOpen
        ? _c("div", {
            staticClass: "mobile-nav-mask",
            on: { click: _vm.closeMobileMenu },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide", mode: "out-in" } },
        [
          _vm.isMobileMenuOpen
            ? _c("mobile-nav", { on: { hide: _vm.closeMobileMenu } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "header-wrap" }, [
        _c("div", { staticClass: "header-top" }, [
          _c(
            "div",
            { staticClass: "item-left" },
            [
              _c("router-link", { staticClass: "logo", attrs: { to: "/" } }, [
                _c("img", {
                  staticClass: "logo-image",
                  attrs: {
                    src: "/assets/images/logos/generic_deal_logo.svg",
                    title: "Africa Dealroom",
                    alt: "Africa Dealroom Logo",
                  },
                }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "item-right" },
            [
              _c("account-menu"),
              _vm._v(" "),
              _c("div", { staticClass: "mobile-controls" }, [
                _c(
                  "a",
                  {
                    attrs: { "aria-label": "menu" },
                    on: { click: _vm.openMobileMenu },
                  },
                  [_c("menu-icon")],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        !_vm.isMinHeader
          ? _c("div", { staticClass: "header-bottom" }, [
              _c(
                "div",
                { staticClass: "item-block" },
                [
                  _c(
                    "router-link",
                    {
                      class: { opened: _vm.extended === "tdb-dealroom-menu" },
                      attrs: { to: "/", "aria-label": "TDB Deal Room" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.hideExtendedMenu.apply(null, arguments)
                        },
                        mouseover: function ($event) {
                          return _vm.showExtendedMenu("tdb-dealroom-menu")
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v("TDB Deal Room")]),
                      _vm._v(" "),
                      _c("chevron-up"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "item-caption" }, [
                    _vm._v(
                      "Great funding opportunities for African businesses"
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.extended === "tdb-dealroom-menu"
                    ? _c("tdb-dealroom-menu", {
                        directives: [
                          {
                            name: "on-clickaway",
                            rawName: "v-on-clickaway",
                            value: _vm.hideExtendedMenu,
                            expression: "hideExtendedMenu",
                          },
                        ],
                        staticClass: "extended-menu tdb-dealroom-menu",
                        on: { hide: _vm.hideExtendedMenu },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }